function ContactSection() {
  return (
    <section id="contact" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          联系我们
        </h2>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-10 border border-secondary-200/50 text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-send-line text-2xl text-primary-600"></i>
            </div>
            <h3 className="font-heading text-xl text-foreground-900 mb-3">欢迎投稿与反馈</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6">
              如果您有优质影片资源推荐、使用建议或合作意向，欢迎通过以下方式与我们联系。
              草民影院期待与每一位热爱电影的影迷交流，共同打造更流畅、更高清的即点即看观影体验。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <span className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 text-background-50 rounded-lg text-sm cursor-pointer whitespace-nowrap">
                <i className="ri-mail-line"></i> contact@caomin.tv
              </span>
              <span className="inline-flex items-center gap-2 px-6 py-3 border border-secondary-300 text-foreground-700 rounded-lg text-sm cursor-pointer whitespace-nowrap">
                <i className="ri-wechat-line"></i> 微信公众号：草民影院
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function CardsSection() {
  const cards = [
    {
      title: '动作爽片合集',
      desc: '肾上腺素飙升的动作大片，1080P蓝光画质还原每一帧爆破细节，高清不卡即点即看。',
      img: 'https://readdy.ai/api/search-image?query=Action%20movie%20explosive%20scene%20with%20warm%20golden%20lighting%2C%20epic%20car%20chase%20at%20sunset%2C%20cinematic%20wide%20shot%2C%20rich%20amber%20and%20orange%20tones%2C%20film%20poster%20aesthetic%2C%20no%20text%2C%20dynamic%20mood&width=800&height=500&seq=card-01&orientation=landscape',
    },
    {
      title: '悬疑烧脑剧场',
      desc: '层层反转的推理神作与心理惊悚，高清画质让每一个线索细节都纤毫毕现。',
      img: 'https://readdy.ai/api/search-image?query=Mystery%20detective%20office%20scene%20with%20warm%20desk%20lamp%20glow%2C%20vintage%20clutter%20and%20case%20files%2C%20cinematic%20noir%20lighting%2C%20rich%20amber%20and%20shadow%20tones%2C%20no%20text%2C%20atmospheric%20mood&width=800&height=500&seq=card-02&orientation=landscape',
    },
    {
      title: '高分剧集推荐',
      desc: '豆瓣高分超清电视剧一网打尽，流畅不缓冲，周末连刷的最佳伴侣。',
      img: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20TV%20glowing%20warm%20light%2C%20comfortable%20couch%20and%20throw%20blankets%2C%20golden%20ambient%20lighting%2C%20soft%20warm%20tones%2C%20cinematic%20cozy%20atmosphere%2C%20no%20text&width=800&height=500&seq=card-03&orientation=landscape',
    },
    {
      title: '科幻视觉盛宴',
      desc: '震撼的太空史诗与未来畅想，1080P蓝光画质呈现令人窒息的视觉奇观。',
      img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cityscape%20at%20sunset%20with%20warm%20golden%20sky%2C%20flying%20vehicles%20silhouettes%2C%20cinematic%20epic%20composition%2C%20rich%20amber%20and%20copper%20tones%2C%20no%20text%2C%20atmospheric%20haze&width=800&height=500&seq=card-04&orientation=landscape',
    },
    {
      title: '经典永流传',
      desc: '影史不朽名作高清修复，用1080P蓝光画质重新发现经典之美。',
      img: 'https://readdy.ai/api/search-image?query=Vintage%20cinema%20film%20reel%20with%20warm%20nostalgic%20glow%2C%20old%20movie%20posters%20on%20brick%20wall%2C%20golden%20sepia%20tones%2C%20retro%20theater%20atmosphere%2C%20no%20text%2C%20elegant%20composition&width=800&height=500&seq=card-05&orientation=landscape',
    },
    {
      title: '纪录片精选',
      desc: '真实世界的震撼与感动，超清画质让自然与人文之美触手可及。',
      img: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20with%20warm%20golden%20sunlight%20over%20mountains%2C%20cinematic%20aerial%20shot%2C%20rich%20amber%20and%20earth%20tones%2C%20breathtaking%20landscape%2C%20no%20text%2C%20atmospheric%20haze&width=800&height=500&seq=card-06&orientation=landscape',
    },
  ];

  return (
    <section id="cards" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          精彩推荐
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="group bg-background-100 rounded-xl overflow-hidden border border-secondary-200/40 hover:border-secondary-300/60 transition-colors cursor-pointer"
            >
              <div className="aspect-video overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturesSection() {
  const features = [
    {
      icon: 'ri-4k-line',
      title: '1080P蓝光画质',
      desc: '全线内容支持超清蓝光画质，每一帧都是视觉享受，即点即看，告别等待。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '高清不卡顿',
      desc: '智能CDN加速与自适应码率技术，确保不同网络环境下均能流畅观影。',
    },
    {
      icon: 'ri-refresh-line',
      title: '每日持续更新',
      desc: '日均50+部热门电影与超清电视剧上线，内容库始终保持新鲜与丰富。',
    },
    {
      icon: 'ri-device-line',
      title: '多端畅享',
      desc: 'PC、平板、手机全面适配，随时随地享受流畅不缓冲的1080P观影体验。',
    },
  ];

  return (
    <section id="features" className="scroll-mt-16 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          平台优势
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-50 rounded-xl p-6 border border-secondary-200/40 hover:border-accent-200/60 transition-colors cursor-pointer text-center"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-accent-100/70 flex items-center justify-center">
                <i className={`${feat.icon} text-2xl text-accent-600`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function TopicsSection() {
  const topics = [
    { label: '1080P蓝光', hot: true },
    { label: '高清电影', hot: true },
    { label: '超清电视剧', hot: false },
    { label: '不卡顿', hot: true },
    { label: '即点即看', hot: false },
    { label: '动作大片', hot: true },
    { label: '悬疑烧脑', hot: false },
    { label: '科幻巨制', hot: false },
    { label: '暑期档', hot: true },
    { label: '经典重映', hot: false },
  ];

  return (
    <section id="topics" className="scroll-mt-16 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-10">
          热门话题
        </h2>
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic) => (
              <span
                key={topic.label}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm cursor-pointer transition-colors whitespace-nowrap ${
                  topic.hot
                    ? 'bg-accent-100/80 text-accent-700 hover:bg-accent-200/80 font-medium'
                    : 'bg-secondary-100/80 text-foreground-600 hover:bg-secondary-200/80'
                }`}
              >
                {topic.hot && <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>}
                {topic.label}
                {topic.hot && (
                  <span className="text-xs text-accent-500 ml-0.5">热</span>
                )}
              </span>
            ))}
          </div>
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
            {['暑期档大片', '豆瓣高分', '悬疑推理', '科幻冒险', '动作激战',
              '温情治愈', '动画电影', '纪录片', '犯罪心理', '历史传记'].map((tag) => (
              <span
                key={tag}
                className="text-center px-3 py-2.5 bg-background-100 rounded-lg border border-secondary-200/40 text-xs text-foreground-600 hover:text-primary-600 hover:border-primary-200/60 cursor-pointer transition-colors whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default function SectionsC() {
  return (
    <>
      <ContactSection />
      <CardsSection />
      <FeaturesSection />
      <TopicsSection />
    </>
  );
}